import { ImageIcon, SkeletonLoading } from '@saleshandy/design-system';
import { InfoCircle } from '@saleshandy/icons';
import React from 'react';
import { Label } from 'reactstrap';
import { Images } from '../../../../../../../shared/app-constants';

const TemplateDetailSkeleton = ({
  enrichProspect = true,
  showSkeleton = true,
}) => (
  <>
    <div
      className={`enrich-own-prompt-container ${
        showSkeleton ? '' : 'enrich-prompt'
      }`}
    >
      {showSkeleton && (
        <div className="enrich-own-prompt-content-container">
          <div className="enrich-own-prompt-label-container">
            <Label className="enrich-own-prompt-label">
              Update or Create Target Column
            </Label>
            {enrichProspect && (
              <InfoCircle className="header-info-circle-icon" />
            )}
          </div>
          <div className="enrich-own-prompt-input-skeleton-column">
            <SkeletonLoading width={281} height={8} className="skeleton" />
          </div>
        </div>
      )}
      <div className="enrich-own-prompt-content-container">
        <div className="enrich-own-prompt-label-container ai-model">
          <Label className="enrich-own-prompt-label">Select AI Model</Label>
        </div>
        <div className="select-ai-options-skeleton">
          <div className="icon-ai-skeleton">
            <SkeletonLoading width={16} height={16} className="skeleton" />
            <SkeletonLoading width={200} height={8} className="skeleton" />
          </div>
          <SkeletonLoading width={16} height={16} className="skeleton" />
        </div>
      </div>
      <div className="enrich-own-prompt-content-container">
        <div className="enrich-own-prompt-label-container">
          <Label className="enrich-own-prompt-label">Enter Instructions</Label>
          <ImageIcon src={Images.Help} alt="help-icon" />
        </div>
        <div className="enrich-own-prompt-input-skeleton">
          <SkeletonLoading width="20%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="80%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="80%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="100%" height={8} className="skeleton" />
          <SkeletonLoading width="80%" height={8} className="skeleton" />
        </div>
      </div>
      <div className="enrich-own-prompt-content-container">
        <div className="enrich-own-prompt-label-container">
          <Label className="enrich-own-prompt-label">Output Format</Label>
          <InfoCircle className="header-info-circle-icon" />
        </div>
        <div className="select-output-format-skeleton">
          <SkeletonLoading width={200} height={8} className="skeleton" />
          <SkeletonLoading width={16} height={16} className="skeleton" />
        </div>
      </div>
    </div>
  </>
);

export default TemplateDetailSkeleton;
